module.exports = __webpack_public_path__ + "static/body_4-0632c8229951391d47ebfea52ae67902.png";